import {DataSetForm} from '../Form/types';
import {showErrorMessage} from '../../_shared/Messages/actions/MessageActions';
import {gwtBuildFormServerCall} from '../../_shared/GWTBridge/invoke/netForm';
import messagesText from '../../_shared/Messages/texts';
import {processServerResponse} from '../../services/wcfService';

export async function buildReactFormServerCall(methodName, parameters, reason) {
    return new Promise(async (resolve, reject) => {
        const result: any = await buildFormServerCall(methodName, parameters, reason, false);
        const hasMessage = processServerMessages(resolve, reject, result);
        if (!hasMessage) resolve(result);
    });
}

enum messageTypes {
    error,
    stop,
    warning,
    exclamation,
    question,
    information
}

export function processServerMessages(resolve, reject, data) {
    const form: DataSetForm = data.Form;

    if (!form?.[0]?.Error && !form?.[0]?.Warning) return false;

    if (form?.[0]?.Error) {
        const {message, messagetype} = form[0].Error[0];

        showErrorMessage({
            content: '',
            title: message,
            confirmButtonText: messagesText.accept,
            onConfirm: () => {
                if (messagetype === messageTypes[messageTypes.stop]) {
                    resolve(data);
                } else {
                    reject();
                }
            },
            onClose: () => {
                resolve(data);
            }
        });
    }

    return true;
}

export function buildFormServerCall(
    methodName,
    parameters,
    reason,
    isProcessServerAnswerGWT = true,
    showLoader = true,
    addToQueue = true,
    session = null,
    userState = ''
) {
    return new Promise((resolve, reject) => {
        if (gwtBuildFormServerCall) {
            gwtBuildFormServerCall(
                methodName,
                parameters,
                reason,
                isProcessServerAnswerGWT,
                processServerResponse(resolve, reject),
                showLoader,
                addToQueue || isProcessServerAnswerGWT,
                session,
                userState
            );
        } else {
            reject('buildServerCall is undefined');
        }
    });
}
